<template>
  <div class="matrixx">
    <h5 class="mb-3" v-html="question.the_question" />
    <MatrixxGrid
      :question="question"
      :preview="true"
      :recipient_id="recipient_id"
      v-if="hasResponses"
    />
    <div class="whisper" v-else>No response yet</div>
  </div>
</template>

<script lang="ts">
import MatrixxGrid from '@app/components/MatrixxGrid.vue'
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'

export default {
  components: { MatrixxGrid },
  props: ['question', 'recipient_id'],
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses']),
    questionIds() {
      return this.question.rows.map((row) => row.id)
    },
    hasResponses() {
      return this.surveyResponses.some((resp) => {
        return this.questionIds.includes(resp.question_id)
      })
    },
  },
}
</script>

<style lang="sass" scoped>
h5
  line-height: 140%
  margin-bottom: 16px
.matrixx
  pointer-events: none
</style>
